import React from "react";

import "./css/home.css";
import Logo from "./img/logo.jpeg";
const Home = () => {
  return (
    <div className="Home">
      <section id="home">
        <div className="container">
          <div className="row">
            <div
              className=" col col-md-6"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div>
                <h2>Hi, I'm Kishor Kumar K</h2>
              </div>
              <h4 style={{ "font-family": "Crete Round, serif" }}>
                Software Developer
              </h4>
              <div>
                <p>
                  Hi, I'm Kishor Kumar, an Angular Developer with 8 months of experience at Vidhvath Technologies. I specialize in building responsive web applications using Angular and have basic knowledge of .NET and backend development.
                </p>
              </div>

              <div>
                <button className="btn btn-outline-primary ms-auto px-4 rounded-pill">
          
                  <a href="#Contact" style={{ textDecoration: "none" }}>
                    <i className="fa-solid fa-arrow-right"></i> Contact Me{" "}
                  </a>{" "}
                </button>
              </div>

              <div className="btns">
                <button className="btn btn-primary ms-auto px-4 rounded-pill">
         
                  <a
                    href="#about"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    {" "}
                    <i className="fa-solid fa-arrow-down"></i> Scroll Down{" "}
                  </a>{" "}
                </button>
              </div>
            </div>

            <div
              className=" col col-md-6 img"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img src={Logo} alt="pop" className="img-responsive" height="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
